<template>
  <v-dialog v-model="dialog.show" max-width="600">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-list :disabled="true">
          <v-row dense>
            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-img
                      contain
                      max-height="200"
                      max-width="200"
                      :src="lead.foto ? 'data:image/png;base64,' + lead.foto : ''"
                    ></v-img>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Veiculo</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.nomeVeiculo }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Celular</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.celular }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Comentarios</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.comentarios }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Data de Criacao</v-list-item-title>
                  <v-list-item-subtitle>{{ $functions.formatDateFirebase(lead.dataCriacao.seconds) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Data de Proximo Contato</v-list-item-title>
                  <v-list-item-subtitle>{{ $functions.formatDateFirebase(lead.dataProxContato.seconds) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Dono do Lead</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.donoDoLead }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Empresa</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.empresa }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Pagamento</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.formaDePagamento }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Nome</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.nome }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Status</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.status }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Termometro</v-list-item-title>
                  <v-list-item-subtitle>{{ lead.termometro }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vendedor } from "@/services/lead";

export default {
  name: "DialogDetalhes",

  data() {
    return {
      dialog: {
        show: false,
        title: "Detahles"
      },
      lead: {
        celular: "",
        comentarios: "",
        dataCriacao: new Date(),
        dataProxContato: new Date(),
        donoDoLead: "",
        empresa: "",
        formaDePagamento: "",
        idVeiculo: "",
        location: {
          latitude: 0,
          longitude: 0
        },
        nome: "",
        nomeVeiculo: "",
        origem: "",
        status: "",
        termometro: "",
        tipoOrigem: ""
      },
      serviceLeadsVendedor: new Vendedor()
    };
  },

  methods: {
    async show(lead) {
      try {
        this.lead = { ...lead };
        await this.getEmpresa(this.lead);
        await this.getColaborador(this.lead);
        await this.getImagemVeiculo(this.lead);
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getEmpresa(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getEmpresa(lead);
        this.lead.empresa = response[0].nome;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getColaborador(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getColaborador(lead);
        this.lead.donoDoLead = response[0].nome;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getImagemVeiculo(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getImagenVeiculo(lead);
        this.lead.foto = response[0].foto;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
};
</script>
